import { render, staticRenderFns } from "./ProductoCreate.vue?vue&type=template&id=df01fe3c&scoped=true&"
import script from "./ProductoCreate.vue?vue&type=script&lang=js&"
export * from "./ProductoCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df01fe3c",
  null
  
)

export default component.exports